import Layout from "./Layout";

export default function TermsConditions() {
  return (
    <Layout>
      <div className="bg-white text-black">
        <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-10 py-12 lg:py-16">
          {/* Page Header */}
          <div className="mb-10">
            <h1 className="text-3xl sm:text-4xl font-serif font-semibold tracking-wide">
              Terms & Conditions
            </h1>

            <div className="w-16 h-1 bg-hover_dark_primary mt-4 mb-6"></div>

            <p className="text-sm text-gray-600">
              <span className="font-semibold text-black">Effective Date:</span>{" "}
              August 31, 2026
            </p>
          </div>

          {/* Introduction */}
          <div className="space-y-5 text-[15px] sm:text-base leading-7 text-gray-700">
            <p>
              Welcome to <strong className="text-black">Legacy Decor</strong>{" "}
              (“Legacy Decor”, “we”, “us”, “our”). These Terms & Conditions
              govern your access to and use of{" "}
              <strong className="text-black">www.legacydecor.in</strong> (the
              “Website”) and the purchase of products offered through the
              Website.
            </p>

            <p>
              By accessing the Website, browsing our products or placing an
              order, you agree to be bound by these Terms & Conditions. If you
              do not agree with these terms, please do not use the Website or
              place an order.
            </p>
          </div>

          {/* Terms Sections */}
          <div className="mt-10 space-y-9 text-[15px] sm:text-base leading-7 text-gray-700">
            {/* 1 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                1. About Legacy Decor
              </h2>

              <p>
                Legacy Decor offers home décor, gifting articles and related
                products through its online platform.
              </p>

              <p className="mt-3">
                All products displayed on the Website are subject to
                availability.
              </p>
            </section>

            {/* 2 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                2. Product Information
              </h2>

              <p>
                We make reasonable efforts to ensure that product descriptions,
                photographs, dimensions, colours, specifications and other
                information displayed on the Website are accurate.
              </p>

              <p className="mt-3">However:</p>

              <ul className="list-disc pl-6 mt-3 space-y-1">
                <li>
                  Actual colours may vary depending on your device, monitor or
                  screen settings.
                </li>
                <li>
                  Handmade, handcrafted, natural or textured products may have
                  minor variations in colour, texture, finish, grain, pattern or
                  appearance.
                </li>
                <li>
                  Such natural or manufacturing variations shall not ordinarily
                  be considered defects.
                </li>
                <li>
                  Product dimensions may have minor variations where applicable.
                </li>
                <li>
                  Product photographs may contain styling or decorative elements
                  that are not included with the purchased product unless
                  specifically stated.
                </li>
              </ul>

              <p className="mt-4">
                We reserve the right to correct errors, inaccuracies or
                omissions and to update product information without prior
                notice.
              </p>
            </section>

            {/* 3 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                3. Product Availability
              </h2>

              <p>All products are subject to availability.</p>

              <p className="mt-3">
                If a product becomes unavailable after you place an order, we
                may contact you regarding the order and may, where appropriate,
                cancel the affected order and process a refund of the amount
                actually paid for that product.
              </p>
            </section>

            {/* 4 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                4. Pricing
              </h2>

              <p>
                All prices displayed on the Website are in Indian Rupees (INR),
                unless otherwise stated.
              </p>

              <p className="mt-3">
                Prices, discounts, promotional offers and shipping charges may
                be changed at any time without prior notice.
              </p>

              <p className="mt-3">
                The applicable price for an order shall ordinarily be the price
                displayed at the time the order is successfully placed.
              </p>
            </section>

            {/* 5 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                5. Placing an Order
              </h2>

              <p>By placing an order, you confirm that:</p>

              <ul className="list-disc pl-6 mt-3 space-y-1">
                <li>
                  The information provided by you is accurate and complete.
                </li>
                <li>You are authorised to use the payment method selected.</li>
                <li>
                  You have reviewed the product, quantity, price and delivery
                  details before placing the order.
                </li>
                <li>
                  You agree to pay all applicable charges associated with the
                  order.
                </li>
              </ul>

              <p className="mt-4">
                An order confirmation does not necessarily constitute acceptance
                of the order by Legacy Decor. We reserve the right to accept,
                decline or cancel an order in accordance with applicable law.
              </p>
            </section>

            {/* 6 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                6. Order Acceptance and Cancellation
              </h2>

              <p>
                Legacy Decor reserves the right to cancel an order in
                circumstances including:
              </p>

              <ul className="list-disc pl-6 mt-3 space-y-1">
                <li>Product unavailability</li>
                <li>Incorrect pricing or product information</li>
                <li>Suspected fraudulent or unauthorised transactions</li>
                <li>Inability to deliver to the provided address</li>
                <li>Duplicate orders</li>
                <li>Operational or technical errors</li>
                <li>
                  Any other legitimate reason permitted under applicable law
                </li>
              </ul>

              <p className="mt-4">
                Where an order is cancelled by Legacy Decor after payment has
                been received, the applicable amount paid for the cancelled
                order will be refunded through the original payment method,
                subject to applicable payment-processing timelines.
              </p>
            </section>

            {/* 7 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                7. Payments
              </h2>

              <p>
                Payments may be processed through third-party payment gateways
                or payment service providers.
              </p>

              <p className="mt-3">
                Legacy Decor does not ordinarily store complete payment-card
                details such as full card numbers or CVV information on its own
                systems.
              </p>

              <p className="mt-3">
                Payment transactions may be subject to the terms, conditions and
                privacy policies of the relevant payment service provider.
              </p>
            </section>

            {/* 8 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                8. Shipping and Delivery
              </h2>

              <p>
                Orders are delivered to the address provided by the customer at
                the time of purchase.
              </p>

              <p className="mt-3">
                Delivery timelines displayed on the Website are estimates and
                may vary due to factors including:
              </p>

              <ul className="list-disc pl-6 mt-3 space-y-1">
                <li>Courier delays</li>
                <li>Weather conditions</li>
                <li>Natural events</li>
                <li>Public holidays</li>
                <li>Regulatory restrictions</li>
                <li>Remote delivery locations</li>
                <li>Incorrect or incomplete address information</li>
                <li>Other circumstances beyond our reasonable control</li>
              </ul>

              <p className="mt-4">
                For further information, please refer to our{" "}
                <strong className="text-black">Shipping Policy</strong>.
              </p>
            </section>

            {/* 9 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                9. Returns, Refunds and Exchanges
              </h2>

              <p>
                Legacy Decor follows a{" "}
                <strong className="text-black">
                  no-general-return/no-change-of-mind policy
                </strong>
                .
              </p>

              <p className="mt-3">
                Returns, exchanges or refunds are not ordinarily available for:
              </p>

              <ul className="list-disc pl-6 mt-3 space-y-1">
                <li>Change of mind</li>
                <li>Personal preference</li>
                <li>Product no longer being required</li>
                <li>Incorrect selection</li>
                <li>Colour or appearance preference</li>
                <li>
                  Product not matching the customer's décor or expectations
                </li>
                <li>Incorrect size/variant selected by the customer</li>
                <li>Any other reason unrelated to transportation damage</li>
              </ul>

              <p className="mt-4">
                If a product is damaged during transportation, the customer must
                report the damage within{" "}
                <strong className="text-black">24 hours of delivery</strong> and
                provide the required photographs/videos and packaging evidence.
              </p>

              <p className="mt-3">
                Please refer to our{" "}
                <strong className="text-black">Refund & Damage Policy</strong>{" "}
                for complete details.
              </p>

              <p className="mt-3">
                Nothing in this section is intended to exclude any rights or
                remedies that cannot lawfully be excluded under applicable law.
              </p>
            </section>

            {/* 10 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                10. Customer Responsibilities
              </h2>

              <p>Customers are responsible for:</p>

              <ul className="list-disc pl-6 mt-3 space-y-1">
                <li>Providing a complete and accurate delivery address</li>
                <li>
                  Providing a reachable telephone number and email address
                </li>
                <li>
                  Being available to receive the shipment or arranging
                  appropriate receipt
                </li>
                <li>Inspecting fragile products promptly upon delivery</li>
                <li>
                  Following product-specific care, installation and usage
                  instructions
                </li>
                <li>
                  Providing accurate information when raising a support or
                  damage claim
                </li>
              </ul>
            </section>

            {/* 11 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                11. Intellectual Property
              </h2>

              <p>
                All content appearing on the Website, including but not limited
                to:
              </p>

              <ul className="list-disc pl-6 mt-3 space-y-1">
                <li>Logos</li>
                <li>Brand names</li>
                <li>Product photographs</li>
                <li>Graphics</li>
                <li>Text</li>
                <li>Designs</li>
                <li>Product descriptions</li>
                <li>Website layout</li>
                <li>Icons</li>
                <li>Videos</li>
                <li>Other visual or written material</li>
              </ul>

              <p className="mt-4">
                is owned by or licensed to Legacy Decor and is protected by
                applicable intellectual-property laws.
              </p>

              <p className="mt-3">
                No content may be copied, reproduced, modified, distributed,
                published or commercially exploited without prior written
                permission from Legacy Decor.
              </p>
            </section>

            {/* 12 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                12. Website Use
              </h2>

              <p>You agree not to:</p>

              <ul className="list-disc pl-6 mt-3 space-y-1">
                <li>Use the Website for unlawful purposes</li>
                <li>
                  Attempt to gain unauthorised access to the Website or its
                  systems
                </li>
                <li>Introduce malicious code, viruses or harmful software</li>
                <li>Interfere with Website functionality</li>
                <li>
                  Use automated systems to scrape or copy Website content
                  without permission
                </li>
                <li>Submit false or misleading information</li>
                <li>Engage in fraudulent or abusive activity</li>
              </ul>
            </section>

            {/* 13 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                13. Third-Party Services
              </h2>

              <p>
                The Website may use third-party services including payment
                gateways, courier partners, analytics providers, communication
                platforms and other service providers.
              </p>

              <p className="mt-3">
                Legacy Decor is not responsible for interruptions or failures
                caused solely by third-party systems, although we will make
                reasonable efforts to assist customers where appropriate.
              </p>
            </section>

            {/* 14 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                14. Limitation of Liability
              </h2>

              <p>
                To the extent permitted by applicable law, Legacy Decor shall
                not be responsible for indirect, incidental, special or
                consequential losses arising from the use of the Website or
                purchase of products.
              </p>

              <p className="mt-3">
                Nothing in these Terms & Conditions excludes or limits liability
                where such exclusion or limitation is prohibited under
                applicable law.
              </p>
            </section>

            {/* 15 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                15. Force Majeure
              </h2>

              <p>
                Legacy Decor shall not be responsible for delay or failure in
                performing its obligations where such delay or failure results
                from circumstances beyond its reasonable control, including
                natural disasters, fire, flood, war, strikes, government
                restrictions, transportation disruptions, epidemics, technical
                failures or other force-majeure events.
              </p>
            </section>

            {/* 16 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                16. Privacy
              </h2>

              <p>
                Your use of the Website and our handling of personal information
                are governed by our{" "}
                <strong className="text-black">Privacy Policy</strong>, which
                forms part of these Terms & Conditions.
              </p>
            </section>

            {/* 17 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                17. Changes to These Terms
              </h2>

              <p>
                Legacy Decor may update these Terms & Conditions from time to
                time.
              </p>

              <p className="mt-3">
                The updated version will be posted on the Website with the
                revised effective date. Continued use of the Website after such
                changes constitutes acceptance of the updated terms, to the
                extent permitted by applicable law.
              </p>
            </section>

            {/* 18 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                18. Governing Law and Jurisdiction
              </h2>

              <p>
                These Terms & Conditions shall be governed by the laws of India.
              </p>

              <p className="mt-3">
                Subject to applicable consumer-protection laws and
                jurisdictional requirements, disputes shall be subject to the
                jurisdiction of the courts having appropriate jurisdiction over{" "}
                <strong className="text-black">Ahmedabad, Gujarat</strong>.
              </p>
            </section>

            {/* 19 */}
            <section>
              <h2 className="text-xl font-semibold text-black mb-3">
                19. Contact Information
              </h2>

              <div className="space-y-2">
                <p>
                  <strong className="text-black">Legacy Decor</strong>
                </p>

                <p>
                  Website:{" "}
                  <a
                    href="https://www.legacydecor.in/"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:text-hover_dark_primary hover:underline transition"
                  >
                    www.legacydecor.in
                  </a>
                </p>

                <p>
                  Legal Entity:{" "}
                  <strong className="text-gray-500">Legacy Decor</strong>
                </p>

                <p>
                  Registered/Business Address:{" "}
                  <span>
                    Shop No. 6, Ratnakar Atelier, Jodhpur Gam Road, Ramdev
                    Nagar, Satellite, Ahmedabad, Gujarat 380015
                  </span>
                </p>

                <p>
                  Email:{" "}
                  <a
                    href="mailto:legacydecorvintage@gmail.com"
                    className="hover:text-hover_dark_primary hover:underline transition"
                  >
                    legacydecorvintage@gmail.com
                  </a>
                </p>

                <p>
                  Phone/WhatsApp:{" "}
                  <a
                    href="tel:+919825081632"
                    className="hover:text-hover_dark_primary hover:underline transition"
                  >
                    (+91) 9825081632
                  </a>
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
}
